/**
 * Everything personal about the portfolio page lives here: profile, socials,
 * and the two project shelves. Edit this file, nothing else, to change the
 * content of the landing page.
 */
import hypeStackLogo from "@/assets/images/icon.png";
import hyperFetchLogo from "@/assets/images/logo-hyperfetch.png";
import rzppLogo from "@/assets/images/logo-rzpp.png";

export type SocialLink = {
  id: "github" | "x" | "linkedin" | "youtube";
  label: string;
  url: string;
};

export type SaasProject = {
  id: string;
  name: string;
  /** Imported image URL, the project's real logo. */
  icon: string;
  tagline: string;
  url: string;
  /**
   * Monthly revenue in USD, oldest first. Only shown when the backend has no
   * Polar token; otherwise the live numbers win. `month` is an ISO month like
   * "2026-08".
   */
  revenue: { month: string; value: number }[];
};

export type OpenSourceProject = {
  id: string;
  name: string;
  /** Imported image URL, the project's real logo. */
  icon: string;
  tagline: string;
  url: string;
  /** npm packages whose downloads are combined into one chart. */
  packages: string[];
};

export const profile = {
  name: "Maciej Pyrc",
  bio: "I maintain open source libraries and build products on top of them.",
  /** The bold half of the downloads pill. */
  downloadsHighlight: "10M+",
  /** The rest of the downloads pill. */
  downloadsRest: "/mo",
  /** Sits right above the subscribe form, so it ends pointing at it. */
  sharing: "I share how I build systems, great-looking websites, and SaaS that sells 👇",
  newsletterTitle: "Get my newsletter",
  newsletterDescription: "How I build open source tools and turn them into products.",
};

/** Update these to your real handles. */
export const socials: SocialLink[] = [
  { id: "github", label: "GitHub", url: "https://github.com/prc5" },
  { id: "x", label: "X", url: "https://x.com/maciej_pyrc" },
  { id: "linkedin", label: "LinkedIn", url: "https://www.linkedin.com/in/maciej-pyrc" },
];

export const saasProjects: SaasProject[] = [
  {
    id: "hype-stack",
    name: "Hype Stack",
    icon: hypeStackLogo,
    tagline: "Full-stack template with installable feature packs",
    url: "https://hype-stack.dev",
    // Fallback only: the card shows live Polar numbers whenever the backend has a token.
    revenue: [
      { month: "2025-09", value: 0 },
      { month: "2025-10", value: 0 },
      { month: "2025-11", value: 0 },
      { month: "2025-12", value: 0 },
      { month: "2026-01", value: 0 },
      { month: "2026-02", value: 0 },
      { month: "2026-03", value: 0 },
      { month: "2026-04", value: 0 },
      { month: "2026-05", value: 0 },
      { month: "2026-06", value: 0 },
      { month: "2026-07", value: 0 },
      { month: "2026-08", value: 0 },
    ],
  },
];

export const openSourceProjects: OpenSourceProject[] = [
  {
    id: "hyper-fetch",
    name: "HyperFetch",
    icon: hyperFetchLogo,
    tagline: "Type-safe data fetching for any framework",
    url: "https://hyperfetch.bettertyped.com",
    packages: ["@hyper-fetch/core", "@hyper-fetch/react", "@hyper-fetch/sockets"],
  },
  {
    id: "react-zoom-pan-pinch",
    name: "react-zoom-pan-pinch",
    icon: rzppLogo,
    tagline: "Zoom, pan and pinch any React component",
    url: "https://github.com/BetterTyped/react-zoom-pan-pinch",
    packages: ["react-zoom-pan-pinch"],
  },
  {
    id: "hype-stack-cli",
    name: "Hype Stack CLI",
    icon: hypeStackLogo,
    tagline: "The CLI that composes Hype Stack projects",
    url: "https://hype-stack.dev",
    packages: ["@hype-stack/cli"],
  },
];
